import React, { ReactNode } from 'react';
import { Divider, Typography } from '@mui/material';
import { CloseIcon, Button, ButtonProps, IconButton } from '~/index.ts';

type DialogButtonProps = Pick<
  ButtonProps,
  'children' | 'variant' | 'onClick' | 'color'
>;

enum ModalWidth {
  small = '445px',
  medium = '600px',
  large = '900px',
}
export interface DialogContentProps {
  title: string;
  bodyContent: ReactNode;
  primaryButton: DialogButtonProps;
  secondaryButton: DialogButtonProps;
  onCancel: () => void;
  size?: 'small' | 'medium' | 'large';
}
const DialogContent: React.FC<DialogContentProps> = ({
  title,
  bodyContent,
  primaryButton,
  secondaryButton,
  onCancel,
  size = 'small',
}) => (
  <div style={{ width: ModalWidth[size] }}>
    <div
      style={{
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="h4">{title}</Typography>
      <IconButton
        onClick={onCancel}
        styleOverrides={{
          margin: 'auto 0 auto auto',
        }}
        IconComponent={CloseIcon}
      />
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '8px 24px 24px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          marginBottom: '30px',
          fontSize: '16px',
        }}
      >
        {bodyContent}
      </div>
      <Divider />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Button
          variant={secondaryButton.variant ?? 'outlined'}
          color={secondaryButton.color ?? 'default'}
          onClick={secondaryButton.onClick}
        >
          {secondaryButton.children}
        </Button>
        <Button
          variant={primaryButton.variant ?? 'contained'}
          color={primaryButton.color ?? 'primary'}
          onClick={primaryButton.onClick}
        >
          {primaryButton.children}
        </Button>
      </div>
    </div>
  </div>
);

export default DialogContent;
